import { useMemo, useState } from "react";
import { getItemsHeights } from "../core/getItemsHeights.js";
import { getItemsInterestedByScroll } from "../core/getItemsInterestedByScroll.js";
import { getItemsTotalHeight } from "../core/getItemsTotalHeight.js";
import { getItemsWithPosition } from "../core/getItemsWithPosition.js";
import { useMaintainScrollPosition } from "./useMaintainScrollPosition.js";
function useItems(props, scrollApiRef) {
  const { items, listHeight, buffer = 0, getItemHeights } = props;
  const [scrollY, setScrollY] = useState(0);
  const [itemsWithPosition, itemsTotalHeight] = useMemo(() => {
    const itemsHeights = getItemsHeights({ items, getItemHeights });
    return [
      // Record of Items with pre-computed `y` and `height`
      getItemsWithPosition({ items, itemsHeights }),
      // Total list height
      getItemsTotalHeight({ itemsHeights })
    ];
  }, [items, getItemHeights]);
  const renderedItems = useMemo(() => {
    return getItemsInterestedByScroll({
      buffer,
      scrollY,
      listHeight,
      itemsTotalHeight,
      itemsWithPosition
    });
  }, [itemsWithPosition, listHeight, itemsTotalHeight, buffer, scrollY]);
  const onScroll = useMaintainScrollPosition(
    props,
    scrollY,
    setScrollY,
    itemsWithPosition,
    renderedItems,
    scrollApiRef
  );
  return {
    onScroll,
    renderedItems,
    itemsTotalHeight,
    itemsWithPosition
  };
}
export {
  useItems
};
//# sourceMappingURL=useItems.js.map
